var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8941 17.8309L12.5002 17.662L12.1062 17.8309L6.2085 20.3585V5.20833C6.2085 4.92102 6.32263 4.64547 6.5258 4.4423C6.72896 4.23914 7.00451 4.125 7.29183 4.125H17.7085C17.9958 4.125 18.2714 4.23914 18.4745 4.4423L19.1758 3.74104L18.4745 4.4423C18.6777 4.64547 18.7918 4.92102 18.7918 5.20833V20.3585L12.8941 17.8309Z",
    stroke: "#93929C",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/Save.7b9b7a721b541668e88133ec8c951083.svg";
export { ForwardRef as ReactComponent };